import dayjs from 'dayjs';

export async function fetchMenus({ pageQuery, selectedFilter, store, api }) {
  try {
    const pageQueryFilter = pageQuery.filter;
    const reqQuery = { query_id: pageQueryFilter || selectedFilter };
    const { url, params } = store.getters.getDiningApi(api.defaults.baseURL);
    const response = await api.get(url, {
      params: {
        ...params,
        ...reqQuery,
      },
      cache: { ignoreCache: false },
    });
    const {
      menus,
      meta: { links },
    } = response.data;
    return {
      menus,
      selectedFilter: pageQueryFilter,
      links,
    };
  } catch {
    throw new Error('error fetching menus');
  }
}

export async function fetchFiltersAndDisclaimer({ store, pageQuery = {}, api }) {
  const { url, params } = store.getters.getDiningApi(api.defaults.baseURL);

  store.dispatch('setCustomSectionData', { type: 'menus', fallbackSectionName: 'Dining' });

  try {
    const diningApiResponse = await api.get(url, { params, cache: { ignoreCache: false } });
    const {
      meta: { queries: diningFilters, disclaimer },
    } = diningApiResponse.data;
    const defaultFilter = diningFilters.find(({ name }) => name.toUpperCase() === 'THIS WEEK') || diningFilters[0];

    store.commit('setDynamicPageFilters', {
      type: 'dining',
      filters: diningFilters,
    });
    store.commit('setDiningDisclaimer', disclaimer);

    const selectedFilter = pageQuery.filter || defaultFilter.id;

    const menus = await fetchMenus({
      pageQuery,
      selectedFilter,
      store,
      api,
    });
    return {
      selectedFilter,
      menus: menus.menus,
      links: menus.links,
    };
  } catch {
    throw new Error('error fetching filters and disclaimer');
  }
}

export function formatDate(date) {
  return dayjs(date).format('dddd, MMM D');
}
